import React from 'react';
import '../../assets/scss/_common.scss';

const ExitComponent = ({ title, question, button }) => (
  <div>
    <div className="blurred-background" />
    <div className="overlay-container">
      <div className="exit-view">
        <p className="exit-title">
          {title}
        </p>
      </div>
      <div className="overlay-question-view">
        <p className="question-text">
          {question}
        </p>
      </div>
      {button}
    </div>
  </div>
);

export default ExitComponent;
